import type { IdentityPort } from './identity';
import type { PreferencesPort } from './preferences';
import type { RecordsPort } from './records';
import { LocalIdentity } from '@/adapters/local/identity';
import { LocalPreferences } from '@/adapters/local/preferences';
import { LocalRecords } from '@/adapters/local/records';

export type BackendKind = 'local' | 'http';

export interface Backend {
  kind: BackendKind;
  identity: IdentityPort;
  records: RecordsPort;
  preferences: PreferencesPort;
}

/**
 * The single place the app learns where its data lives.
 *
 * Adding the D1 backend is: write `src/adapters/http/*` implementing the same
 * three ports against the Worker's API, and add a branch here. No screen, hook
 * or domain function changes, because none of them import an adapter.
 */
export function createBackend(): Backend {
  return {
    kind: 'local',
    identity: new LocalIdentity(),
    records: new LocalRecords(),
    preferences: new LocalPreferences(),
  };
}

export type { IdentityPort, Profile, ProfileDraft } from './identity';
export type { PreferencesPort, Preferences } from './preferences';
export type { RecordsPort } from './records';
